import React, { FC } from 'react'
import { isMobile } from 'react-device-detect'

import { FilterTypeContainer } from '../filter-type-container'
import { CheckboxList } from '../checkbox-list'
import { MenuSlider } from '../menu-slider'
import { Text } from '../text'

import { FilterListProps } from './filter-list.types'
import { useStyle } from './filter-list.styles'

export const FilterList: FC<FilterListProps> = ({
  className = '',
  title,
  titleTx,
  ...checkboxProps
}) => {
  const classes = useStyle()

  const titlePreset = isMobile ? 'h5' : 'h4'
  const titleComponent = <Text text={title} tx={titleTx} preset={titlePreset} />

  if (checkboxProps.data.length > 9) {
    return (
      <MenuSlider
        className={`${className} ${classes.slider}`}
        contentClassName={classes.sliderContent}
        titleClassName={classes.sliderTitle}
        header={titleComponent}
      >
        <CheckboxList {...checkboxProps} />
      </MenuSlider>
    )
  }

  return (
    <FilterTypeContainer className={className} title={title} titleTx={titleTx}>
      <CheckboxList {...checkboxProps} />
    </FilterTypeContainer>
  )
}
